import { UncompleteTasks as DefaultBulkUncompleteTasksButton } from 'customer-data-bulk-actions/components/buttons/tasks/UncompleteTasks';
import { DefaultBulkActionsUncompleteTasksModalOnSuccess } from 'customer-data-bulk-actions/components/buttons/tasks/UncompleteTasks';
import { NOT_STARTED } from 'customer-data-objects/engagement/EngagementStatusTypes';
import { STATUS } from 'customer-data-objects/task/TaskPropertyNames';
import { useCallback } from 'react';
import { TASK_INTERACTION_TYPES } from '../../constants/table';
import { useDispatch } from '../../context/Redux';
import { useTableContext } from '../../context/TableContext';
import { useTemporarilyExcludeIds } from '../../hooks/useTemporarilyExcludeIds';
import { logBulkActionUpdate, mergeTaskPropertyUpdates } from '../../redux/actions/tasksCRUD';
import { jsx as _jsx } from "react/jsx-runtime";
const UNCOMPLETE_TASK_PROPERTY_UPDATE = [{
  name: STATUS,
  value: NOT_STARTED
}];
export default function BulkUncompleteTasks({
  allSelected,
  clearSelection,
  selection
}) {
  const {
    onDelayedRefreshSearch
  } = useTableContext();
  const dispatch = useDispatch();
  const temporarilyExcludeIds = useTemporarilyExcludeIds();
  const onSuccess = useCallback(({
    count
  }) => {
    DefaultBulkActionsUncompleteTasksModalOnSuccess({
      count
    });
    if (!allSelected) {
      temporarilyExcludeIds(selection, TASK_INTERACTION_TYPES.UNCOMPLETE_TASKS);
    }
    dispatch(mergeTaskPropertyUpdates({
      taskIds: selection,
      propertyUpdates: UNCOMPLETE_TASK_PROPERTY_UPDATE
    }));
    onDelayedRefreshSearch();
    clearSelection();
  }, [dispatch, selection, temporarilyExcludeIds, allSelected, clearSelection, onDelayedRefreshSearch]);
  return /*#__PURE__*/_jsx(DefaultBulkUncompleteTasksButton, {
    buttonProps: {
      onSuccess,
      logFunction: logBulkActionUpdate
    }
  });
}